import { render, staticRenderFns } from "./modalImpressao.vue?vue&type=template&id=4fdb971a"
import script from "./modalImpressao.vue?vue&type=script&lang=js"
export * from "./modalImpressao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports